<template>
    <div>
        <v-row dense v-show="paySlip.workerCode">
            <v-col cols="12" md="6">
                <v-card>
                    <v-card-actions>
                        <h2>
                            {{ `${paySlip.workerLastName} ${paySlip.workerFirstName}` }}
                            <v-btn
                                    icon
                                    color="blue"
                                    @click="$router.push({name: 'blank_pay_slips.workers.view', params: {id: paySlip.workerId, backPath: 'blank_pay_slips'}})"
                            >
                                <v-icon> mdi-account-circle-outline</v-icon>
                            </v-btn>
                        </h2>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
                <v-tabs
                        v-model="tab"
                        dense
                        height="35"
                        fixed-tabs
                        class="elevation-5"
                        color="teal"
                        background-color="cyan lighten-3"
                >
                    <v-tab
                            v-for="t in paySectionPositions"
                            :key="`tab-${t}`"
                    >
                        {{ $t(`common.${t}`) }}
                    </v-tab>
                    <v-tab-item
                            v-for="t in paySectionPositions"
                            :key="`tab-item-${t}`"
                    >
                        <v-card flat>
                            <v-card-text>
                                <v-simple-table dense fixed-header height="370"
                                                style="border-collapse: collapse; border: 1px solid black; ">
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left" style="width: 0;">
                                                {{ $t("common.code") }}
                                            </th>
                                            <th class="text-left">
                                                {{ $t("common.label") }}
                                            </th>
                                            <th class="text-left">
                                                {{ $t("common.value") }}
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template
                                                v-for="(detail, index) in getItems(paySlip.details.filter(d => d.position === t && d.selected))"
                                        >
                                            <tr
                                                    :key="`full-fix-${index}`"
                                                    v-if="detail !== 'empty'"
                                            >
                                                <td style="width: 0;">
                                                    <v-tooltip right>
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <span v-bind="attrs" v-on="on">
                                                            {{ detail.code }}
                                                          </span>
                                                        </template>
                                                        <span>{{ detail.formule }}</span>
                                                    </v-tooltip>
                                                </td>
                                                <td>
                                                    {{ detail.label }}
                                                </td>
                                                <td>
                                                    {{ showValue(detail) }}
                                                </td>
                                            </tr>
                                            <tr
                                                    class="emptytr"
                                                    :key="`empty-fix-${index}`"
                                                    v-else
                                            >
                                                <td colspan="3"></td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table
                        dense
                        height="60"
                >
                    <tbody>
                    <tr>
                        <td style="background-color: #80cbc4">
                            TOTAL DES GAINS
                            <h2>
                                <strong>{{ priceFormat(paySlip.totalGains) }}</strong>
                            </h2>
                        </td>
                        <td style="background-color: #ef9a9a">
                            TOTAL DES RETENUES
                            <h2>
                                <strong>{{ priceFormat(paySlip.totalRetenues) }}</strong>
                            </h2>
                        </td>
                        <td style="background-color: #90caf9">
                            NET A PAYER
                            <h2>
                                <strong>{{ priceFormat(paySlip.net) }}</strong>
                            </h2>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <v-tabs
                        dense
                        fixed-tabs
                        class="elevation-5"
                        color="teal"
                        height="35"
                        background-color="yellow"
                >
                    <v-tab>{{ $t("pay_slip.bulletin") }}</v-tab>
                    <v-tab>Toutes</v-tab>
                    <v-tab>Paramètres</v-tab>
                    <v-tab>Congé et Soldes</v-tab>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <pay-slip-component :pay_slip="paySlip" hide-detail/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card>
                            <v-card-text>
                                <all-pay-slip-details :paySlip="paySlip"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <worker-pay-slip :worker-id="paySlip.workerId"/>
                    </v-tab-item>
                    <v-tab-item>
                        <worker-balance
                                :workerId="paySlip.workerId"
                        ></worker-balance>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import WorkerBalance from "@/views/Worker/Components/WorkerBalance.vue";
import AllPaySlipDetails from "@/views/PaySlip/Components/AllPaySlipDetails.vue";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";
import {computed, ref} from "vue";
import WorkerPaySlip from "@/views/PaySlip/Components/WorkerPaySlip.vue";

export default {
    name: "BlankPaySlipDetails",
    components: {WorkerPaySlip, AllPaySlipDetails, WorkerBalance},
    props: {
        paySlip: Object,
    },
    setup(props) {
        const {priceFormat} = useSharedMethod();
        const {loading} = useSharedData();

        const variables = computed(() => props.paySlip.details.filter(detail => detail.position === 'VARIABLE' && detail.selected))
        const fixes = computed(() => props.paySlip.details.filter(detail => detail.position === 'FIX' && detail.selected))
        const result = computed(() => props.paySlip.details.filter(detail => detail.position === 'RESULT' && detail.selected))


        function showValue(item) {
            return item.calculated ? "Calculé" : priceFormat(item.value);
        }


        const paySectionPositions = ['FIX', 'VARIABLE', 'RESULT'];
        const tab = ref(0);

        function getItems(items) {
            let result = [];
            let i = 0;
            while (i < 20 && result.length <= 20) {
                const filterResult = items.filter(item => item.ordre === i);
                if (filterResult.length > 0) {
                    filterResult.forEach(item => {
                        result.push(item);
                    });
                } else {
                    result.push('empty');
                }
                i++;
            }
            return result;
        }

        return {
            loading,
            paySectionPositions,
            tab,
            variables,
            fixes,
            result,
            showValue,
            getItems,
            priceFormat
        }
    },
}
</script>

<style scoped>
.emptytr {
    background-color: #FFE0B2;
}
</style>